import { DashboardMetrics } from '../../../types/Dashboard'

type MetricsOverlayProps = {
    metrics: DashboardMetrics
}

export function formatKwToMw(kw: number | null): string {
    if (kw === null) {
        return 'No data'
    }
    if (kw >= 1000) {
        return `${(kw / 1000).toFixed(1)} MW`
    }
    return `${kw} kW`
}

export function MetricsOverlay({ metrics }: MetricsOverlayProps) {
    const alertCount = metrics.alerts.length

    return (
        <div className="metrics-overlay">
            <div className="metrics-card">
                <div className="metrics-label">Baseload Under Management</div>
                <div className="metrics-value">{formatKwToMw(metrics.totalBaseloadKw)}</div>
            </div>
            <div className="metrics-card">
                <div className="metrics-label">Flex Being Used</div>
                <div className="metrics-value">{formatKwToMw(metrics.totalFlexUsedKw)}</div>
            </div>
            <div className={`metrics-card ${alertCount > 0 ? 'metrics-card--warning' : ''}`}>
                <div className="metrics-label">Alerts</div>
                <div className="metrics-value">{alertCount}</div>
            </div>
        </div>
    )
}
